// extracted by mini-css-extract-plugin
module.exports = {"heroOnly":"BelowHeroWrapper_heroOnly__3SBSS"};